import PropTypes from 'prop-types';
import { Link } from '@blaze-cms/nextjs-components';

const HeaderMenu = ({ href, name, items }) => (
  <li className="menu__list-item menu__list-item--main">
    <Link href={href} className="menu__link menu__link--main">
      {name}
    </Link>

    {(items || []).length > 0 && (
      <div className="menu__children">
        <ul className="submenu__list">
          {items.map(({ itemKey, href: linkHref, name: linkName }) => (
            <li key={itemKey} className="submenu__list-item submenu__list-item--has-submenu">
              <Link href={linkHref}>{linkName}</Link>
            </li>
          ))}
        </ul>
      </div>
    )}
  </li>
);

HeaderMenu.propTypes = {
  href: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired
};

export default HeaderMenu;
